export default __webpack_public_path__ + "static/media/II2021.84e8b5de.pdf";